(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-stone-service-card-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-service-card-grid')) {
  customElements.define('ss-service-card-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('.ssc-see-details');
        if (button && this.contains(button)) {
          const dialog = document.getElementById(button.getAttribute('aria-controls'));
          if (dialog && this.contains(dialog)) this.openDetails(dialog, button);
        }
        const close = event.target.closest('.ssc-close');
        if (close && this.contains(close)) close.closest('dialog').close();
        if (event.target.matches('.ssc-dialog[open]')) {
          const bounds = event.target.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
        }
      }, options);
      this.querySelectorAll('.ssc-dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (this.activeDialog === dialog) this.restorePage();
        }, options);
      });
      // Shopify replaces section markup without reloading the whole page.
      // Custom-element connection/disconnection keeps handlers and scroll locks in sync.
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-service-block]');
        if (!card || !this.contains(card)) return;
        const button = card.querySelector('.ssc-see-details');
        if (button) this.openDetails(document.getElementById(button.getAttribute('aria-controls')), button);
      }, options);
    }

    openDetails(dialog, button) {
      if (!dialog || dialog === this.activeDialog) return;
      if (this.activeDialog) this.activeDialog.close();
      else this.previousOverflow = document.body.style.overflow;
      this.activeDialog = dialog;
      this.opener = button;
      dialog.showModal();
      dialog.querySelector('.ssc-dialog-scroll').scrollTop = 0;
      document.body.style.overflow = 'hidden';
    }

    restorePage() {
      document.body.style.overflow = this.previousOverflow || '';
      this.activeDialog = null;
      if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
      this.opener = null;
    }

    disconnectedCallback() {
      if (this.activeDialog) {
        this.activeDialog.close();
        this.restorePage();
      }
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-installation-quote"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-installation-quote')) {
  customElements.define('ss-installation-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const controller = new AbortController();
      const on = (target, event, callback) => target?.addEventListener(event, callback, { signal: controller.signal });
      const layout = this.closest('#ss-installation-layout');
      const form = this.querySelector('form');
      const card = this.querySelector('.ssiq-card');
      const desktop = this.querySelector('.ssiq-desktop');
      const modal = this.querySelector('dialog');
      const close = this.querySelector('.ssiq-close');
      const mobile = matchMedia('(max-width: 1100px)');
      const status = this.querySelector('.ssiq-status');
      const submit = form.querySelector('[type="submit"]');
      const formView = this.querySelector('[data-form-view]');
      const success = this.querySelector('.ssiq-success');
      const config = JSON.parse(this.querySelector('[data-config]').textContent);
      const widgets = [];
      // Pricing request information.
      const pricingHelp = this.querySelector('[data-pricing-help]');
      const pricingTip = this.querySelector('[data-pricing-tooltip]');
      const pricingHelpWrap = pricingHelp?.closest('[data-pricing-help-wrap]');
      let pricingHelpPinned = false;
      const positionPricingHelp = (allowReflow = false) => {
        if (!pricingTip || pricingTip.hidden || !pricingHelpWrap) return;
        // Keep an expanded panel in normal flow while the page/form scrolls.
        if (pricingHelpWrap.classList.contains('ssiq-help-inline') && allowReflow !== true) return;
        const rect = pricingHelp.getBoundingClientRect();
        const viewport = window.visualViewport;
        const viewportTop = (viewport?.offsetTop || 0) + 12;
        const viewportBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 12;
        const cardRect = modal.open ? card.getBoundingClientRect() : null;
        const stickyTop = parseFloat(this.style.getPropertyValue?.('--ssiq-top'));
        const top = Math.max(viewportTop, cardRect ? cardRect.top + 12 : Number.isFinite(stickyTop) ? stickyTop + 12 : viewportTop);
        const bottom = Math.min(viewportBottom, cardRect ? cardRect.bottom - 12 : viewportBottom);
        const above = Math.max(0, rect.top - top - 10);
        const below = Math.max(0, bottom - rect.bottom - 10);
        const fullHeight = pricingTip.scrollHeight;
        const expandInline = fullHeight > Math.max(above, below);
        const showBelow = !expandInline && fullHeight > above;
        pricingHelpWrap.classList.toggle('ssiq-help-inline', expandInline);
        pricingHelpWrap.classList.toggle('ssiq-help-below', showBelow);
      };
      const closePricingHelp = () => {
        pricingHelpPinned = false;
        if (pricingTip) pricingTip.hidden = true;
        pricingHelp?.setAttribute('aria-expanded', 'false');
        pricingHelpWrap?.classList.remove('ssiq-help-open');
        pricingHelpWrap?.classList.remove('ssiq-help-inline');
        pricingHelpWrap?.classList.remove('ssiq-help-below');
      };
      const showPricingHelp = () => {
        if (!pricingTip || !pricingHelpWrap) return;
        pricingTip.hidden = false;
        pricingHelp.setAttribute('aria-expanded', 'true');
        pricingHelpWrap.classList.add('ssiq-help-open');
        positionPricingHelp(true);
      };
      if (pricingHelp && pricingTip && pricingHelpWrap) {
        on(pricingHelpWrap, 'pointerenter', event => { if (event.pointerType !== 'touch') showPricingHelp(); });
        on(pricingHelpWrap, 'pointerleave', () => { if (!pricingHelpPinned && !pricingHelpWrap.contains(document.activeElement)) closePricingHelp(); });
        on(pricingHelp, 'focus', showPricingHelp);
        on(pricingHelp, 'click', () => {
          if (pricingHelpPinned) closePricingHelp();
          else { pricingHelpPinned = true; showPricingHelp(); }
        });
        on(pricingHelpWrap, 'focusout', event => { if (!pricingHelpWrap.contains(event.relatedTarget)) closePricingHelp(); });
        on(document, 'pointerdown', event => { if (!pricingHelpWrap.contains(event.target)) closePricingHelp(); });
        on(this, 'keydown', event => {
          if (event.key === 'Escape' && !pricingTip.hidden) {
            event.preventDefault(); event.stopPropagation(); closePricingHelp();
          }
        });
        on(modal, 'cancel', event => { if (!pricingTip.hidden) { event.preventDefault(); closePricingHelp(); } });
        on(window, 'resize', () => positionPricingHelp(true));
        on(window, 'scroll', positionPricingHelp);
        on(window.visualViewport, 'resize', () => positionPricingHelp(true));
        on(window.visualViewport, 'scroll', positionPricingHelp);
        on(card, 'scroll', positionPricingHelp);
      }
      // End pricing request information.

      // A tall desktop form follows the page instead of clipping its own menus.
      const syncCardSize = () => {
        const top = parseFloat(this.style.getPropertyValue?.('--ssiq-top')) || 100;
        this.classList.toggle('ssiq-tall-card', !mobile.matches && (card.offsetHeight || 0) > (window.innerHeight || 800) - top - 20);
      };
      const cardSizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(syncCardSize) : null;
      const positionMenus = () => widgets.forEach(widget => widget.position?.());
      on(window, 'resize', () => { syncCardSize(); positionMenus(); });
      on(window.visualViewport, 'resize', positionMenus);
      on(window.visualViewport, 'scroll', positionMenus);
      on(window, 'scroll', positionMenus);
      on(card, 'scroll', positionMenus);

      let sending = false;
      let returnFocus;
      let scrollState;
      const track = (event, parameters = {}) => {
        if (typeof window.gtag === 'function') window.gtag('event', event, parameters);
        else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event, ...parameters }); }
      };
      const syncRows = () => {
        if (layout) layout.style.setProperty('--ssiq-rows', Math.max(1, [...layout.children].filter(node => node.classList.contains('shopify-section') && !node.contains(this)).length));
      };
      syncRows();
      const observer = new MutationObserver(syncRows);
      if (layout) observer.observe(layout, { childList: true });
      const syncViewport = () => {
        modal.style.setProperty('--ssiq-vv-top', `${Math.max(0, window.visualViewport?.offsetTop || 0)}px`);
        modal.style.setProperty('--ssiq-vv-height', `${window.visualViewport?.height || innerHeight}px`);
      };
      on(window.visualViewport, 'resize', syncViewport);
      on(window.visualViewport, 'scroll', syncViewport);
      const closeMenus = () => widgets.forEach(widget => widget.close());
      const restore = () => {
        desktop.append(card);
        closeMenus();
        closePricingHelp();
        if (scrollState) {
          const saved = scrollState;
          scrollState = null;
          document.body.style.position = saved.position;
          document.body.style.top = saved.top;
          document.body.style.width = saved.width;
          document.body.style.overflow = saved.overflow;
          document.documentElement.style.overflow = saved.htmlOverflow;
          window.scrollTo({ top: saved.y, left: saved.x, behavior: 'instant' });
        }
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      };
      const open = () => {
        if (mobile.matches) {
          if (modal.open) return;
          returnFocus = document.activeElement;
          const body = document.body;
          scrollState = { x: scrollX, y: scrollY, position: body.style.position, top: body.style.top, width: body.style.width, overflow: body.style.overflow, htmlOverflow: document.documentElement.style.overflow };
          body.style.position = 'fixed'; body.style.top = `-${scrollState.y}px`; body.style.width = '100%'; body.style.overflow = 'hidden'; document.documentElement.style.overflow = 'hidden';
          modal.append(card);
          syncViewport();
          modal.showModal();
          card.scrollTop = 0;
          close.focus({ preventScroll: true });
        } else {
          card.scrollTop = 0;
          const target = this.getBoundingClientRect();
          const stickyTop = parseFloat(getComputedStyle(this).top) || 0;
          if (target.top > stickyTop + 12 || target.top < 0) this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          (success.hidden ? form.elements.first_name : success).focus({ preventScroll: true });
        }
        track('ss_installation_quote_open');
      };
      on(close, 'click', () => modal.close());
      on(modal, 'close', restore);
      on(mobile, 'change', () => { if (modal.open) { modal.close(); restore(); } });
      on(this.querySelector('[data-open-quote]'), 'click', open);
      on(layout, 'click', event => {
        const link = event.target.closest('a[href="#installation-quote"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const title = link.closest('.ss-card')?.querySelector('.ss-card__title')?.textContent.trim();
        const types = { 'Kitchen Countertops': 'Kitchen countertops', 'Bathroom Vanities': 'Bathroom vanity', 'Waterfall Islands': 'Waterfall island', 'Outdoor Kitchens': 'Outdoor kitchen', 'Fireplace & Feature Walls': 'Wall or fireplace', 'Commercial Countertops': 'Commercial project', 'Countertop Replacement': 'Countertop replacement' };
        if (types[title] && success.hidden) { form.elements.project_type.value = types[title]; form.elements.project_type.dispatchEvent(new Event('change', { bubbles: true })); }
        open();
      });
      on(document, 'shopify:section:select', event => { if (event.target.contains(this) && mobile.matches) open(); });
      on(document, 'shopify:section:deselect', event => { if (event.target.contains(this) && modal.open) modal.close(); });
      const phone = form.elements.phone;
      on(phone, 'input', () => {
        let digits = phone.value.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        digits = digits.slice(0, 10);
        phone.value = digits.length < 4 ? digits : digits.length < 7 ? `(${digits.slice(0, 3)}) ${digits.slice(3)}` : `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        phone.setCustomValidity('');
      });
      form.querySelectorAll('select').forEach(select => {
        const shell = document.createElement('div'); shell.className = 'ssiq-custom-select';
        const trigger = document.createElement('button'); trigger.type = 'button'; trigger.className = 'ssiq-select-trigger';
        const menu = document.createElement('div'); menu.className = 'ssiq-select-menu'; menu.id = `${select.id}-options`; menu.hidden = true; menu.setAttribute('role', 'listbox');
        const label = select.closest('.ssiq-field').querySelector('label');
        trigger.setAttribute('aria-label', label.textContent.trim()); trigger.setAttribute('aria-haspopup', 'listbox'); trigger.setAttribute('aria-expanded', 'false'); trigger.setAttribute('aria-controls', menu.id);
        const buttons = [...select.options].filter(option => option.value).map(option => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'ssiq-select-option'; button.textContent = option.textContent; button.dataset.value = option.value; button.setAttribute('role', 'option'); menu.append(button); return button;
        });
        const widget = { select, trigger, shell, close: () => { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }, sync: () => {
          trigger.textContent = select.options[select.selectedIndex].textContent; trigger.classList.toggle('is-placeholder', !select.value); trigger.removeAttribute('aria-invalid');
          buttons.forEach(button => button.setAttribute('aria-selected', String(button.dataset.value === select.value)));
        } };
        widget.position = () => {
          if (menu.hidden) return;
          const rect = trigger.getBoundingClientRect();
          const viewport = window.visualViewport;
          const viewportTop = viewport?.offsetTop || 0;
          const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
          const cardRect = modal.open ? card.getBoundingClientRect() : null;
          const top = Math.max(viewportTop + 12, cardRect ? cardRect.top + 12 : (parseFloat(this.style.getPropertyValue('--ssiq-top')) || 100));
          const bottom = Math.min(viewportBottom - 12, cardRect ? cardRect.bottom - 12 : viewportBottom - 12);
          const below = Math.max(0, bottom - rect.bottom - 8);
          const above = Math.max(0, rect.top - top - 8);
          const openAbove = below < 144 && above > below;
          shell.classList.toggle('ssiq-open-above', openAbove);
          menu.style.setProperty('--ssiq-menu-height', `${Math.max(0, Math.min(240, openAbove ? above : below))}px`);
        };
        const openMenu = () => {
          closeMenus();
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          widget.position();
          const selected = buttons.find(button => button.dataset.value === select.value);
          menu.scrollTop = selected ? Math.max(0, selected.offsetTop - (menu.clientHeight - selected.offsetHeight) / 2) : 0;
        };
        widgets.push(widget); shell.append(trigger, menu); select.after(shell); select.classList.add('ssiq-native-select'); select.tabIndex = -1; select.setAttribute('aria-hidden', 'true'); widget.sync();
        on(trigger, 'click', () => menu.hidden ? openMenu() : widget.close());
        on(trigger, 'keydown', event => { if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); openMenu(); (buttons.find(button => button.dataset.value === select.value) || buttons[0]).focus(); } });
        buttons.forEach((button, index) => {
          on(button, 'click', () => { select.value = button.dataset.value; select.dispatchEvent(new Event('change', { bubbles: true })); widget.close(); trigger.focus({ preventScroll: true }); });
          on(button, 'keydown', event => {
            const next = event.key === 'ArrowDown' ? Math.min(index + 1, buttons.length - 1) : event.key === 'ArrowUp' ? Math.max(0, index - 1) : event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : null;
            if (next !== null) { event.preventDefault(); buttons[next].focus(); }
          });
        });
        on(select, 'change', widget.sync);
        on(label, 'click', event => { event.preventDefault(); trigger.focus(); });
      });
      on(this, 'keydown', event => {
        if (event.key === 'Escape' && widgets.some(widget => widget.trigger.getAttribute('aria-expanded') === 'true')) { event.preventDefault(); const active = widgets.find(widget => widget.trigger.getAttribute('aria-expanded') === 'true'); closeMenus(); active.trigger.focus(); }
      });
      on(document, 'click', event => { if (!widgets.some(widget => widget.shell.contains(event.target))) closeMenus(); });
      on(this, 'focusout', event => { if (!widgets.some(widget => widget.shell.contains(event.relatedTarget))) closeMenus(); });
      const sendJSON = async (url, payload) => {
        const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), keepalive: true });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
      };
      on(form, 'submit', async event => {
        event.preventDefault();
        if (sending || !success.hidden || form.elements.company.value) return;
        phone.setCustomValidity(phone.value.replace(/\D/g, '').length === 10 ? '' : 'Enter a 10-digit phone number.');
        for (const name of ['first_name', 'last_name']) form.elements[name].value = form.elements[name].value.trim();
        if (!form.checkValidity()) {
          const invalid = form.querySelector(':invalid');
          const widget = widgets.find(item => item.select === invalid);
          if (widget) { widget.trigger.setAttribute('aria-invalid', 'true'); widget.trigger.focus(); }
          else form.reportValidity();
          return;
        }
        const values = Object.fromEntries(new FormData(form));
        const parameters = new URLSearchParams(location.search);
        const payload = { source: 'signature_stone_installation_page', form_name: 'Countertop Installation Quote', page_id: config.pageId, first_name: values.first_name, last_name: values.last_name, name: `${values.first_name} ${values.last_name}`, phone: values.phone, project_type: values.project_type, approximate_size: values.approximate_size, project_details: values.project_details.trim(), source_url: location.href, page_title: document.title, referrer: document.referrer || '', submitted_at: new Date().toISOString() };
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'].forEach(key => { payload[key] = parameters.get(key) || ''; });
        sending = true; submit.disabled = true; submit.textContent = 'Sending…'; status.textContent = ''; form.setAttribute('aria-busy', 'true');
        track('ss_installation_quote_submit', { project_type: payload.project_type });
        try {
          const jobs = [sendJSON(form.action, payload)];
          const webhook = (config.makeWebhookUrl || '').trim();
          if (webhook) jobs.push(sendJSON(webhook, payload));
          await Promise.any(jobs);
          this.querySelector('[data-success-name]').textContent = values.first_name;
          formView.hidden = true; success.hidden = false; card.scrollTop = 0; success.focus({ preventScroll: true });
          track('generate_lead', { form_name: payload.form_name, project_type: payload.project_type });
          track('ss_installation_quote_success', { project_type: payload.project_type });
        } catch (error) {
          status.textContent = 'We could not send your request. Please try again or call/text (775) 505-9500.';
          track('ss_installation_quote_error');
        } finally {
          sending = false; submit.disabled = false; submit.textContent = 'Request pricing'; form.removeAttribute('aria-busy');
        }
      });
      on(this.querySelector('.ssiq-reset'), 'click', () => { form.reset(); phone.setCustomValidity(''); widgets.forEach(widget => widget.sync()); success.hidden = true; formView.hidden = false; status.textContent = ''; card.scrollTop = 0; if (mobile.matches) close.focus({ preventScroll: true }); else form.elements.first_name.focus({ preventScroll: true }); });
      this.classList.add('ssiq-ready');
      cardSizeObserver?.observe(card);
      syncCardSize();
      this.cleanup = () => {
        closePricingHelp();
        controller.abort(); observer.disconnect(); cardSizeObserver?.disconnect();
        if (modal.open) modal.close();
        restore();
        widgets.forEach(widget => { widget.shell.remove(); widget.select.classList.remove('ssiq-native-select'); widget.select.removeAttribute('tabindex'); widget.select.removeAttribute('aria-hidden'); });
        this.classList.remove('ssiq-ready');
        layout?.style.removeProperty('--ssiq-rows');
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
